<app-camera class="wide" (getPicture)="handleImage($event)"></app-camera>

<div class="webcam-image" *ngIf="webcamImage">
  <img id="file" [src]="webcamImage.imageAsDataUrl" />
</div>

<label for="file">File:</label>
<input type="file" (change)="upload($event)" accept=".png,.jpg" />
<button (click)="uploadImage()">Upload Image</button>
